"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const WebpSupportHelper_1 = __importDefault(require("@react/web/Common/WebpSupportHelper/WebpSupportHelper"));
const CarListingOfferListItemView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/CarListingOfferListItemView"));
const MergedCarListingOfferListItemView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/MergedCarListingOfferListItemView"));
const CarListingOfferListItemComponent = ({ handleClick, listingOffer, simpleOffer, showMergedOffer, isSmallScreen, filterCount, isListingOffersListEmpty, }) => {
    if (showMergedOffer === true) {
        return (0, MergedCarListingOfferListItemView_1.default)({
            handleClick,
            isWebpSupported: (0, WebpSupportHelper_1.default)(),
            listingOffer,
            simpleOffer,
            isListingOffersListEmpty,
            isSmallScreen,
        });
    }
    return (0, CarListingOfferListItemView_1.default)({
        isWebpSupported: (0, WebpSupportHelper_1.default)(),
        listingOffer,
        simpleOffer,
        filterCount,
        isSmallScreen,
    });
};
exports.default = CarListingOfferListItemComponent;
